// extracted by mini-css-extract-plugin
export default {"preview":"LoaderPreview_preview__6L3e7","noPreview":"LoaderPreview_noPreview__nCLyi"};